<script>
import Layout from '@layouts/loggedin.vue'
import { authComputed } from '@state/helpers'
import Tab from '@router/components/tab.vue'
import Tabs from '@router/components/tabs.vue'
import Hubs from '@reports/components/hubs.vue'
import Groups from '@reports/components/groups.vue'
import Individuals from '@reports/components/individuals.vue'
import Events from '@reports/components/events.vue'

export default {
  components: {
    Layout,
    Tab,
    Tabs,
    Hubs,
    Groups,
    Individuals,
    Events,
  },
  computed: { ...authComputed },
}
</script>

<template>
  <Layout>
    <div class="bg-white px-7.5 pt-4 pb-6 text-xl">
      <span class="">Admin</span>
      <span class="breadcrumb-separator">&gt;</span>
      <span class="text-blue">My Giving Reports</span>
    </div>

    <div>
      <Tabs
        :classes="'bg-white flex justify-around border-none'"
        :parent-classes="'bg-white flex justify-center'"
        :tab-classes="
          'border-b-5 pb-5 text-xl mr-16 leading-loose cursor-pointer'
        "
      >
        <Tab
          title='<svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 24.861 25.805" class="inline-block align-middle mr-1"><path id="Path_129" data-name="Path 129" d="M38.27,10.678l-12.545.031V7.5H13.41V33.305H14.5V20.224H24.636v2.925H38.271l-3.842-6.236ZM24.636,19.135H14.5V8.589H24.636ZM36.3,22.059H25.725V11.8H36.306l-3.172,5.117Z" transform="translate(-13.41 -7.5)" fill="currentColor" /></svg> <span class="align-middle">Hubs</span>'
        >
          <div :class="$style.tabContent">
            <Hubs />
          </div>
        </Tab>
        <Tab
          title='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 896.11 1000" width="25" height="25" fill="currentColor" class="inline-block align-middle mr-1"><title>Kyndhub_Groups_Icon</title><path d="M857.9,580l-5.49-1.27V421.27l5.53-1.23a114.68,114.68,0,0,0,90.11-112.48,116.12,116.12,0,0,0-201.2-79.43l-3.85,4.1L609.58,155.14l1.31-5.2a145.3,145.3,0,0,0,5.41-33.39,116.5,116.5,0,0,0-233-.11v.11a89.39,89.39,0,0,0,5.16,32.77l2.09,5.61-133.5,77.34-3.85-4.1A116,116,0,1,0,142,420l5.49,1.27V578.69L142,580A116,116,0,1,0,253.21,771.83l3.85-4.1,133.09,77.13-1.31,5.2a145.3,145.3,0,0,0-5.41,33.39,116.5,116.5,0,0,0,233,.11v-.11a89.39,89.39,0,0,0-5.16-32.77l-2.09-5.61,133.66-77.46,3.85,4.09A116,116,0,1,0,857.9,579.84ZM832.83,231.78a74.59,74.59,0,0,1,74.51,74.51v.16a75.59,75.59,0,0,1-74.51,74.23,74.51,74.51,0,0,1,0-149ZM501.36,43.43a74.51,74.51,0,0,1,0,149,73.72,73.72,0,0,1-74.51-72.94c0-.52,0-1,0-1.57A74.59,74.59,0,0,1,501.36,43.43ZM96.77,307.56a74.51,74.51,0,1,1,74.51,74.55H171A75.58,75.58,0,0,1,96.77,307.56Zm73.12,459.35a74.51,74.51,0,1,1,74.51-74.59,74.51,74.51,0,0,1-74.51,74.59h0ZM501.36,956.53a74.52,74.52,0,0,1,0-149,73.73,73.73,0,0,1,74.51,73c0,.52,0,1,0,1.57a74.6,74.6,0,0,1-74.51,74.55Zm215-264.21a82.16,82.16,0,0,0,5,30.93l2.5,5.77-134,77.71-3.85-4.1a115.31,115.31,0,0,0-162.94-6.52q-3.39,3.14-6.52,6.52l-3.85,4.1L279.67,729.59l1.31-5.16a134.55,134.55,0,0,0,5.41-32A116.61,116.61,0,0,0,196.27,580l-5.49-1.27V421.31l5.49-1.27a116.61,116.61,0,0,0,90.12-112.48,82.13,82.13,0,0,0-5-30.93l-2.5-5.77L413,193.27l3.85,4.1a115.31,115.31,0,0,0,162.94,6.52q3.39-3.13,6.52-6.52l3.86-4.1L723,270.41l-1.31,5.16a134.55,134.55,0,0,0-5.41,32A116.61,116.61,0,0,0,806.41,420l5.49,1.27V578.69L806.41,580A116.62,116.62,0,0,0,716.33,692.32Zm115.1,74.51a74.51,74.51,0,1,1,0-149h.25A75.57,75.57,0,0,1,906,692.32,74.6,74.6,0,0,1,831.43,767Z" transform="translate(-51.94 0)"/></svg> <span class="align-middle">Groups</span>'
        >
          <div :class="$style.tabContent">
            <Groups />
          </div>
        </Tab>
        <Tab
          title='<svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21.044 24.049" class="inline-block align-middle mr-1"><g id="Group_244" data-name="Group 244" transform="translate(-453.062 -37.45)"><path id="Path_109" data-name="Path 109" d="M463.593,50.506a6.528,6.528,0,1,0-6.529-6.528A6.546,6.546,0,0,0,463.593,50.506Zm-5.133-6.528a5.139,5.139,0,0,1,5.133-5.133l.133,0a5.135,5.135,0,1,1-5.266,5.135Z" fill="currentColor"/><path id="Path_110" data-name="Path 110" d="M463.584,50.727a10.534,10.534,0,0,0-10.522,10.522v.25h1.4v-.25a9.139,9.139,0,0,1,9.123-9.123h0a9.126,9.126,0,0,1,9.127,9.123v.25h1.15v-.25h.24A10.534,10.534,0,0,0,463.584,50.727Z" fill="currentColor"/></g></svg> <span class="align-middle">Individuals</span>'
        >
          <div :class="$style.tabContent">
            <Individuals />
          </div>
        </Tab>
        <Tab
          title='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 957.8" height="22" fill="currentColor" class="inline-block align-middle mr-1"><title>Kyndhub_Events_Icon</title><path d="M975.44,151.77H783.87V46.68a24.56,24.56,0,0,0-49.08,0V151.82H265.21V46.68a24.56,24.56,0,0,0-49.08-2q0,1,0,2V151.82H24.56A24.56,24.56,0,0,0,0,176.34v778A24.56,24.56,0,0,0,24.56,978.9H975.44A24.56,24.56,0,0,0,1000,954.34h0v-778a24.57,24.57,0,0,0-24.56-24.57Zm-24.56,778H49.08V460.2h901.8Zm0-518.66H49.08V200.9h167v61.87a24.56,24.56,0,0,0,49.08,0V200.9H734.74v61.87a24.57,24.57,0,0,0,49.09,0V200.9h167Z" transform="translate(0 -21.1)" /></svg> <span class="align-middle">Events</span>'
        >
          <div :class="$style.tabContent">
            <Events />
          </div>
        </Tab>
      </Tabs>
    </div>
  </Layout>
</template>

<style lang="scss" module>
.tabContent {
  @apply bg-white mt-8 mx-7.5 px-14 py-14 rounded-xl shadow-box;
}
</style>
